// WU-2.2 — /admin/queue-instructions API client + the operator-facing scoped
// read. Paths WITHOUT the leading "/api" (the shared client prefixes it).
//   GET    /admin/queue-instructions      → { instructions: QueueInstructionRecord[] }
//   PUT    /admin/queue-instructions      → { instruction } (set/REPLACE for scope)
//   DELETE /admin/queue-instructions/:id  → { cleared: true } | 404
//   GET    /queue-instructions?stepType=… → { instructions } (session-only read)
import { api } from "@/lib/api-client";

export interface QueueInstructionRecord {
  id: string;
  tenantId: string;
  stepType: string;
  jobTypeId: string | null;
  body: string;
  createdBy: string;
  createdByName: string | null;
  createdAt: string;
  clearedAt: string | null;
  clearedBy: string | null;
}

export interface ScopedInstruction {
  id: string;
  stepType: string;
  jobTypeId: string | null;
  body: string;
  createdAt: string;
}

export interface PutQueueInstructionPayload {
  stepType: string;
  jobTypeId?: string;
  body: string;
}

export const queueInstructionsApi = {
  list: () =>
    api.get<{ instructions: QueueInstructionRecord[] }>("/admin/queue-instructions"),
  put: (payload: PutQueueInstructionPayload) =>
    api.put<{ instruction: QueueInstructionRecord }>("/admin/queue-instructions", payload),
  delete: (id: string) =>
    api.delete<{ cleared: boolean }>(`/admin/queue-instructions/${id}`),
  forScope: (stepType: string, jobTypeId?: string) =>
    api.get<{ instructions: ScopedInstruction[] }>(
      `/queue-instructions?stepType=${encodeURIComponent(stepType)}${
        jobTypeId ? `&jobTypeId=${encodeURIComponent(jobTypeId)}` : ""
      }`,
    ),
};
